// Product page add wrap div for free shipping block 

(function () {
  function wrapHalfBlocks() {
    const wrapper = document.querySelector('.form__wrapper');
    if (!wrapper) return false;

    const halfBlocks = [...wrapper.children].filter(el =>
      el.className.includes('block') && el.className.includes('half')
    );

    if (
      halfBlocks.length === 2 &&
      !wrapper.querySelector('.product-block-half-wrapper')
    ) {
      const newWrapper = document.createElement('div');
      newWrapper.className = 'product-block-half-wrapper';

      wrapper.insertBefore(newWrapper, halfBlocks[0]);
      halfBlocks.forEach(el => newWrapper.appendChild(el));

      return true;
    }
    return false;
  }

  // Try immediately
  if (wrapHalfBlocks()) return;

  // Observe for late rendering (Shopify)
  const observer = new MutationObserver(() => {
    if (wrapHalfBlocks()) observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function () {

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyAtcSync();
      initStickyAtcVisibility();
    });
  } else {
    initStickyAtcSync();
    initStickyAtcVisibility();
  }

  // -------------------------
  // Sticky ATC sync logic
  // -------------------------
  function initStickyAtcSync() {
    setTimeout(() => {
      const stickySection = document.querySelector('[data-sticky-atc]');
      if (!stickySection) return;

      document.body.classList.add('has-sticky-atc');

      const stickyQty = stickySection.querySelector('[data-sticky-qty] [data-quantity-field]');
      const stickyVariantSelect = stickySection.querySelector('[data-sticky-variant]');
      const addToCartBtn = stickySection.querySelector('[data-sticky-atc-button]');

      const productSection = document.querySelector('[data-section-type="product-template"]');
      if (!productSection) return;

      const productForm = productSection.querySelector('form');
      const mainQty = productSection.querySelector('[data-quantity-holder] [data-quantity-field]');
      const mainAddButton = productSection.querySelector('.product__submit__add');

      // -------------------------
      // Quantity sync
      // -------------------------
      if (mainQty && stickyQty) {
        const syncQty = (from, to) => {
          const value = Math.max(1, parseInt(from.value || '1', 10));
          if (to.value !== String(value)) {
            to.value = value;
            to.dispatchEvent(new Event('input', { bubbles: true }));
            to.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };

        // initial sync
        syncQty(mainQty, stickyQty);

        ['input', 'change'].forEach(evt => {
          mainQty.addEventListener(evt, () => syncQty(mainQty, stickyQty));
          stickyQty.addEventListener(evt, () => syncQty(stickyQty, mainQty));
        });
      }

      // -------------------------
      // Variant sync (CRITICAL FIX)
      // -------------------------
      function syncVariantToMain(variantId) {
        if (!variantId || !productForm) return;

        // 1️⃣ Radio / swatch inputs
        const radioInput = productForm.querySelector(
          `input[type="radio"][value="${variantId}"]`
        );

        if (radioInput) {
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        // 2️⃣ Hidden variant input
        const hiddenInput = productForm.querySelector(
          `input[type="hidden"][name="id"]`
        );

        if (hiddenInput) {
          hiddenInput.value = variantId;
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 3️⃣ Fallback select
        const variantSelect = productForm.querySelector('select[name="id"]');
        if (variantSelect) {
          variantSelect.value = variantId;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Sync variant on sticky change
      if (stickyVariantSelect) {
        syncVariantToMain(stickyVariantSelect.value);

        stickyVariantSelect.addEventListener('change', () => {
          syncVariantToMain(stickyVariantSelect.value);
        });
      }

      // -------------------------
      // Sticky ATC click
      // -------------------------
      if (addToCartBtn && mainAddButton) {
        addToCartBtn.addEventListener('click', (e) => {
          e.preventDefault();

          // Ensure variant is synced BEFORE submit
          if (stickyVariantSelect) {
            syncVariantToMain(stickyVariantSelect.value);
          }

          // Sync quantity
          if (mainQty && stickyQty) {
            mainQty.value = stickyQty.value;
            mainQty.dispatchEvent(new Event('input', { bubbles: true }));
            mainQty.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // Allow theme JS to update variant state
          setTimeout(() => {
            mainAddButton.click();
          }, 50);
        });
      }

    }, 300);
  }

  // -------------------------
  // Sticky ATC visibility
  // -------------------------
  function initStickyAtcVisibility() {
    setTimeout(() => {
      const stickySection = document.querySelector('[data-sticky-atc]');
      const mainQtyHolder = document.querySelector(
        '[data-section-type="product-template"] [data-quantity-holder]'
      );
      const whySection = document.querySelector('.custom-why-this-product');

      if (!stickySection || !mainQtyHolder) return;

      let mainInView = true;
      const requireFullyBypassed = true;

      const evaluate = () => {
        const scrolled = (window.scrollY || window.pageYOffset) > 10;

        try {
          const rect = mainQtyHolder.getBoundingClientRect();
          mainInView = rect.top < window.innerHeight && rect.bottom > 0;
        } catch (e) {
          mainInView = true;
        }

        let whyBypassed = false;
        if (whySection) {
          try {
            const rect = whySection.getBoundingClientRect();
            whyBypassed = requireFullyBypassed ? rect.bottom < 0 : rect.top < 0;
          } catch (e) {}
        }

        stickySection.classList.toggle(
          'is-visible',
          scrolled && (!mainInView || whyBypassed)
        );
      };

      const observer = new IntersectionObserver(() => evaluate(), {
        threshold: [0, 0.01, 1],
        rootMargin: '0px 0px -40% 0px'
      });

      observer.observe(mainQtyHolder);

      window.addEventListener('scroll', evaluate, { passive: true });
      window.addEventListener('resize', evaluate);

      evaluate();
    }, 300);
  }

})();
